__webpack_require__.p = "/stockapp/";